export enum AlgoritmNodeType {
  Family = 0,
  Aggregation = 1,
  Algorithm = 2,
}
